//
//
//
//
//
//
//
//
//
//
//

import zdialog from "@/components/toast/Zdialog.vue";
import cellGrid from "@/components/cellGrid.vue";
import { FactoryUtils } from "@/utils/FactoryUtils"    


export default {
    name:'protocolList',
    data(){
        return {
            treaty:{},
            title:'',
            list:[],
            dialog:false
          }
    },
    props: {
        templateFlag:{ 
            type: String,
            default() { return '' }
        },
        activeItem:{
            type: Array,
            default() { return [] }
        }
    },
    components:{
        zdialog,
        cellGrid
    },
    created(){
      FactoryUtils.treaty().then(res=>{
        this.treaty = res
      })

    },
    methods:{
        show(item){
            console.log(item)
            this.title = item.name;
            this.list = this.treaty[item.flag]
            if(this.list.length == 1){
              this.pdfClick(this.list[0])
            }else{
                this.$refs.zdialog.showoast()
            }
        },
        pdfClick(e){
            console.log(e)
            this.zdialog = false
            // this.STATISTICS('click','sybao_ins_clause_detail_click')
            this.$router.push({
                path: "/pdf",
                query:{
                    insurFlag:this.templateFlag,
                    pdfFlag:e.pdfFlag,
                    flag : 'postdisable'
                }
            });
            this.$refs.zdialog.close()

        }
    }
}
